import script from "./form-media.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-media.vue?vue&type=script&setup=true&lang=ts"

import "./form-media.vue?vue&type=style&index=0&id=3f64e77a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f64e77a"]])

export default __exports__